import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import Swal from 'sweetalert2'
import { getIdList } from './../../Utils/api'
import getAxiosInstance from './../../Utils/axios'
import AddUpdateCountry from '../../Components/AddUpdateCountry';
import AddCountryCsv from '../../Components/AddCountryCsv';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

export default function Country() {
    const [countries, setCountries] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [notAdmin, setNotAdmin] = useState(false);
    const [ids, setIds] = useState([]);
    const [searchFilter, setSearchFilter] = useState("");
    const [limit, setLimit] = useState(20);
    const [pageNumber, setPageNumber] = useState(0);
    const [totalCountries, setTotalCountries] = useState(0);

    const getCountries = () => { 
        let jsonData = {
            limit: limit,
            page: pageNumber * limit,
            search: searchFilter
        };
        if(ids.length > 0) jsonData.ids = getIdList(ids)
        // converting (json --> form-urlencoded)
        const data = Object.keys(jsonData)
        .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
        .join('&');

        getAxiosInstance()
        .post("/admin/countries", data,{
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            })
            .then((res) => {
                // Validating form
                setIsLoading(false);
                if(res.data.status === 'success'){
                    // console.log(res.data);
                    setTotalCountries(res.data.totalCount);
                    setCountries(res.data.result);
                }else if(res.data.status === "error") Toast.fire({ icon: 'error', title: res.data.message })
                else Toast.fire({ icon: 'error', title: "Cannot process request" })
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    }

    useEffect(() => {
        getCountries();
    }, [limit, pageNumber, ids]);

    const changePage = ({ selected }) => setPageNumber(selected);

    const deleteCountry = (id) => {
        Swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            html: '<h5>This country will be deleted?</h5>',
            showCancelButton: true,
            confirmButtonText: `Delete`,
            confirmButtonColor: '#D14343',
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);

                const params = { id: id }
        
                // converting (json --> form-urlencoded)
                const data = Object.keys(params)
                .map((key) => `${key}=${encodeURIComponent(params[key])}`)
                .join('&');

                getAxiosInstance()
                .post("/admin/delete-country", data, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                    })
                .then((res) => {
                    // Validating form
                    setIsLoading(false);
                    if(res.data.status === 'success'){
                        Toast.fire({ icon: 'success', title: "Successfully deleted country" })
                        getCountries();
                    }else{
                        // console.log(res.data);
                        Toast.fire({ icon: 'error', title: "Unable to delete country" })
                    }
                })
                .catch((err) => {
                    Toast.fire({ icon: 'error', title: "Unexpected Error" })
                    setIsLoading(false);
                    console.log(err);
                });
            }
        })
    }

    useEffect(() => {
        getAxiosInstance()
            .get("/admin/me")
            .then((res) => {
                if(res.data.result.user_type !== "admin") {
                    setNotAdmin(true)
                    setIds(res.data.result.location.country);
                }
            })
            .catch((err) => console.log(err));
    },[])

    return (
        <div>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0">Country</h1>
                            </div>
                            <div className="col-sm-6">
                                <div className="float-right">
                                    <AddCountryCsv 
                                        getAxiosInstance={getAxiosInstance}
                                        Toast={Toast}
                                        getCountries={getCountries}
                                    />
                                    <AddUpdateCountry 
                                        type={"add"}
                                        getAxiosInstance={getAxiosInstance}
                                        Toast={Toast}
                                        getCountries={getCountries}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-5">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div class="card-tools">
                                            <div className="input-group input-group-sm" style={{width: 250}}>
                                                <input type="text" name="table_search" className="form-control float-right" placeholder="Search" value={searchFilter} onChange={(e) => setSearchFilter(e.target.value)} />
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default" onClick={() => getCountries()}>
                                                        <i className="fas fa-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Country</th>
                                                    <th>Code</th>
                                                    <th style={{width: 40}}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading && <tr style={{ textAlign: 'center' }}>
                                                    <td colSpan={5}>Loading Countries ...</td>
                                                </tr>}
                                                {!isLoading && totalCountries === 0 && <tr style={{ textAlign: 'center' }}>
                                                    <td colSpan={5}>No Countries Found</td>
                                                </tr>}
                                                {countries?.map((country, i) => (
                                                    <tr key={i}>
                                                        <td>{country.name}</td>
                                                        <td>{country.code}</td>
                                                        <td>
                                                            <div style={{ display: 'flex' }}>
                                                                <AddUpdateCountry 
                                                                    type={"update"}
                                                                    getAxiosInstance={getAxiosInstance}
                                                                    Toast={Toast}
                                                                    getCountries={getCountries}
                                                                    countryUp={country}
                                                                />
                                                                <button type="button" class="btn btn-danger btn-sm ml-1" title="Delete" onClick={() => deleteCountry(country._id)}>
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="card-footer clearfix">
                                        {(totalCountries > limit)?
                                            <ReactPaginate 
                                                previousLabel={"«"}
                                                nextLabel={"»"}
                                                pageCount={Math.ceil(totalCountries / limit)}
                                                onPageChange={changePage}
                                                containerClassName={"pagination pagination-sm m-0 float-right"}
                                                pageClassName={"page-item"}
                                                pageLinkClassName={"page-link"}
                                                // previousClassName={"previous"}
                                                previousLinkClassName={"page-link"}
                                                // nextClassName={"next"}
                                                nextLinkClassName={"page-link"}
                                                disabledClassName={"disabled"}
                                                activeClassName={"active"}
                                            />
                                        :null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
